/*
 * NWF-257: klaviyo.js (forms, popups, onsite tracking) loads only after marketing consent.
 * Replaces the Klaviyo app embed, which loads the script regardless of consent.
 */
(() => {
    'use strict';

    if (window.NwfKlaviyo) return;

    const COMPANY_ID = 'TtsqGa';
    let loaded = false;

    function load() {
        if (loaded) return;
        loaded = true;
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://static.klaviyo.com/onsite/js/${COMPANY_ID}/klaviyo.js?company_id=${COMPANY_ID}`;
        document.head.appendChild(script);
    }

    window.NwfKlaviyo = { load, loaded: () => loaded };

    // The editor preview is not a visitor session.
    if (window.Shopify && window.Shopify.designMode) {
        load();
        return;
    }

    const consent = window.NwfVideoConsent;
    if (!consent) return;

    if (consent.allowed()) load();
    consent.onChange((allowed) => {
        if (allowed) load();
        else if (loaded) window.location.reload();
    });
})();
